import type { InsuranceHighlightsInterface } from '@/modules/common/common/models/APP/types'
import AbstractAccordion from '@/modules/common/common/models/APP/accordions/AbstractAccordion'
import { CURRENCY } from '@/modules/common/common/constants/CommonConstants'

export default class AdditionalCoverageConfig {
  public code: string
  public number: string
  public icon: string
  public label: string
  public headerTitle: string
  public message: string
  public mandatory: boolean
  public capitals: number[]
  public period: string
  public minAge: number
  public maxAge: number

  public defaultValue: number | null
  public min: number
  public max: number
  public step: number
  public hidden: boolean
  public units: string = CURRENCY

  public highlights: InsuranceHighlightsInterface[]
  public sections: AbstractAccordion<any>[]

  constructor(data: Partial<AdditionalCoverageConfig>) {
    this.code = data.code ?? ''
    this.number = data.number ?? ''
    this.icon = data.icon ?? '-- --'
    this.label = data.label ?? '-- --'
    this.headerTitle = data.headerTitle ?? '-- --'
    this.message = data.message ?? ''
    this.mandatory = data.mandatory ?? false
    this.minAge = data.minAge ?? 0
    this.maxAge = data.maxAge ?? 999
    this.capitals = this.#orderCapitals(data.capitals ?? [])
    this.period = data.period ?? ''
    this.defaultValue = this.capitals[0] ?? null
    this.min = this.capitals.at(0) ?? 0
    this.max = this.capitals.at(-1) ?? 0
    this.step = this.#calculateSteps(this.capitals)
    this.hidden = this.capitals.length === 0

    this.highlights = data.highlights ?? []
    this.sections = data.sections ?? []
  }

  #orderCapitals(capitals: number[]) {
    return capitals.sort((a, b) => a - b)
  }

  #calculateSteps(capitals: number[]) {
    if (capitals.length < 2) return 0

    return capitals[1] - capitals[0]
  }
}
